import React, { useEffect } from "react";
import TopLists from "../components/TopLists";
import Footer from "../components/Footer";
import MobileScreen from "../components/MobileScreen";
import { UAParser } from 'ua-parser-js';
import "../css/Home.css";
import Citation from "../components/Citation";

import { Typography, Box, Tabs, Tab, Link } from "@mui/material";
import { Chip } from "@mui/joy";
import { Android, Apple } from "@mui/icons-material";

// import { useLocation, useNavigate } from "react-router-dom";
import { useScraper } from "../components/SelectedScraperProvider";

const TopCharts = ({ flipState }) => {
    // const [selectedScraper, setSelectedScraper] = React.useState("Play Store");
    const { selectedScraper, setSelectedScraper } = useScraper();

    // Should be an undefined object if it's on a laptop
    const userAgent = new UAParser().getDevice();
    const isMobileDevice = userAgent.type === 'mobile';

    // const location = useLocation();
    // const navigate = useNavigate();

    // useEffect(() => {
    //     if (location.state && location.state.selectedScraper) {
    //         setSelectedScraper(location.state.selectedScraper);
    //         //console.log(selectedScraper);
    //     }
    // }, [location.state]);

    // Switch to mobile device screen if user is on a mobile device
    return !isMobileDevice ? (
        <>
            <div className="app-container">
                <div className="content">
                    <Box sx={{ borderBottom: 1, borderColor: "divider",marginTop : 7}}>
                        <Tabs
                            value={selectedScraper ?? "Play Store"}
                            onChange={(_event, newValue) =>
                                setSelectedScraper(newValue)
                            }
                            aria-label="basic tabs example"
                        >
                            <Tab
                                icon={<Android />}
                                iconPosition="start"
                                label="PLAY STORE"
                                value={"Play Store"}
                            />
                            <Tab
                                icon={<Apple />}
                                iconPosition="start"
                                label="APP STORE"
                                value={"App Store"}
                            />
                        </Tabs>
                    </Box>
                    <div className="home-container">
                        <Typography variant="h3" className="home-header">
                            Systematic Mobile Application Reviews - Top Charts
                            <Chip
                                color="success"
                                onClick={function () {}}
                                size="sm"
                                variant="outlined"
                            >
                                BETA
                            </Chip>
                        </Typography>

                        <Typography variant="p" className="home-text">
                            Fetch top charts for different countries, collections, and
                            categories for the{" "}
                            {selectedScraper === "Play Store"
                                ? "Google Play"
                                : "iOS App"}{" "}
                            store.
                        </Typography>
                    </div>
                    <TopLists flipState={flipState} selectedScraper={selectedScraper} />
                </div>
                <Citation />
                <Footer/>
                <br/>
            </div>
        </>
    ) : (
        <MobileScreen />
    );
};

export default TopCharts;
